import {
  useSpeedReducer,
  SpeedContext,
  SpeedDispatchContext,
} from "app/speed/useSpeed";
import { STORAGE_KEY_PREFIX } from "app/utils/useResetableStorage";

interface SpeedProviderProps {
  roundIndex: number;
  children: React.ReactNode;
}

export function SpeedProvider(props: SpeedProviderProps) {
  const [roundState, dispatch] = useSpeedReducer(
    `${STORAGE_KEY_PREFIX}_SPEED_ROUND_STATE_${props.roundIndex}`,
  );
  return (
    <SpeedContext value={roundState}>
      <SpeedDispatchContext value={dispatch}>
        {props.children}
      </SpeedDispatchContext>
    </SpeedContext>
  );
}
